import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';


import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css'
import './setup/i18n';

import { default as routes } from 'src/routes/Routes';


import { authSelector, logOut, setCredentials } from './store/reducers/auth';
import { useRefreshMutation } from './store/api/auth/authApiSlice';

import useError from './hooks/useError';
import { LoadingPage } from './components';
import { isRTL } from './utils/global';
import { getStorageItem } from './utils/storage';

import { cartUpdateItems } from './store/reducers/cart';
import { storageCartReset } from './utils/cart';
import { MALEK_CART_ITEMS_KEY, MALEK_STORE_TOKEN_KEY } from './constants/storageKeys';
import { clearAuthStorage } from './utils/auth';


const App = () => {
  const auth = useSelector(authSelector);
  const [refresh, { isLoading, isError, error }] = useRefreshMutation();
  const dispatch = useDispatch();
  const { showError } = useError();


  // Side Effects
  useEffect(() => {
    if (!auth.access) {
      const reAuthHandle = async () => {
        const refreshToken = await getStorageItem(MALEK_STORE_TOKEN_KEY);
        if (refreshToken) {
          const res = await refresh(refreshToken);
          if ('data' in res) {
            const { access } = res.data;
            const userData = {
              access: access,
              refresh: refreshToken
            }
            dispatch(setCredentials(userData));
          }
        } else {
          clearAuthStorage();
        }
      }
      reAuthHandle();
    }
    const loadCartItems = async () => {
      try {
        const cartItems = await getStorageItem(MALEK_CART_ITEMS_KEY);
        if (cartItems) {
          dispatch(cartUpdateItems({ items: cartItems }));
        }
      } catch (err) {
        console.log("cart err", err);
        storageCartReset();
        dispatch(cartUpdateItems({ items: [] }));
      }

    }
    loadCartItems();
  }, [auth.access, dispatch]);

  useEffect(() => {
    if (isError) {
      if ((error as any).status === 500 || (error as any).status === "FETCH_ERROR") {
        showError(error);
      }
      if ((error as any).status === 401 || (error as any).status === 403) {
        dispatch(logOut());
        clearAuthStorage();
      }
    }
  }, [isError]);

  if (isLoading) {
    return <LoadingPage />
  }


  return (
    <Router>
      <ToastContainer className={isRTL() ? "rtl_toast" : ""} stacked
        position={isRTL() ? 'top-right' : 'top-left'} />
      <Routes>
        {routes.map((route, index) => (
          <Route key={`layout__${index}`} path={route.path} element={<route.element />}>
            {route.routes.map((nestedRoute, nestedIndex) => (
              <Route
                key={`route__${nestedIndex}`}
                path={nestedRoute.path}
                element={<nestedRoute.element />}
              />
            ))}
          </Route>
        ))}
      </Routes>
    </Router>);
}



export default App;
